import gql from "graphql-tag";
import LockablePostFields from "../../fragments/engagement/LockablePostFields";

export default gql`
  mutation UnlockPost($postId: ObjectID!) {
    unlockPost(postId: $postId) {
      ...LockablePostFields
    }
  }

  ${LockablePostFields}
`;
